import React from 'react';
import { NavLink, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Logo from './Logo';
import { openConsentPreferences } from '../consent/consent';

export default function Footer() {
  const { t } = useTranslation();
  const { lang } = useParams();
  const currentLang = lang === 'en' ? 'en' : 'it';
  const home = `/${currentLang}`;

  const goAnchor = (id) => (e) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <footer className="auro-footer" data-testid="site-footer">
      <div className="auro-footer__grid">
        <div className="auro-footer__brand">
          <Logo />
          <p className="auro-footer__tagline">{t('footer.tagline')}</p>
          <a className="auro-footer__mail" href="mailto:info@auronixio.com">info@auronixio.com</a>
        </div>

        <div>
          <h4>{t('footer.exploreTitle')}</h4>
          <ul>
            <li><NavLink to={home}>{t('nav.home')}</NavLink></li>
            <li><a href="#how" onClick={goAnchor('how')}>{t('nav.how')}</a></li>
            <li><a href="#benefits" onClick={goAnchor('benefits')}>{t('nav.benefits')}</a></li>
            <li><a href="#transparency" onClick={goAnchor('transparency')}>{t('nav.transparency')}</a></li>
            <li><a href="#faq" onClick={goAnchor('faq')}>{t('nav.faq')}</a></li>
            <li><a href="#contact" onClick={goAnchor('contact')}>{t('nav.contact')}</a></li>
          </ul>
        </div>

        <div>
          <h4>{t('footer.legalTitle')}</h4>
          <ul>
            <li><NavLink to={`${home}/privacy`}>{t('nav.privacy')}</NavLink></li>
            <li><NavLink to={`${home}/cookies`}>{t('nav.cookies')}</NavLink></li>
            <li><NavLink to={`${home}/terms`}>{t('nav.terms')}</NavLink></li>
            <li>
              <button type="button" className="auro-linkish" onClick={openConsentPreferences}>
                {t('cookies.manage')}
              </button>
            </li>
          </ul>
        </div>

        <div>
          <h4>{t('footer.companyTitle')}</h4>
          <ul className="auro-footer__legal">
            <li>{t('footer.legal.companyName')}</li>
            <li>{t('footer.legal.office')}</li>
            <li>{t('footer.legal.registry')}</li>
            <li>{t('footer.legal.vat')}</li>
            <li>{t('footer.legal.rea')}</li>
            <li>{t('footer.legal.capital')}</li>
            <li>{t('footer.legal.incorporation')}</li>
            <li>{t('footer.legal.jurisdiction')}</li>
            <li className="auro-footer__licence">{t('footer.legal.licence')}</li>
          </ul>
        </div>
      </div>

      <div className="auro-footer__bottom">
        <span>© {new Date().getFullYear()} Auronixio S.r.l. — {t('footer.rights')}</span>
        <span>{t('footer.builtIn')}</span>
      </div>
    </footer>
  );
}
